import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

if (process.env['REACT_APP_MOBILE'] !== '1') {
    console.log('run touch emulator');
    const TouchEmulator = require('hammer-touchemulator');
    TouchEmulator();
    registerServiceWorker();
}

// document.addEventListener('deviceready', function() {
ReactDOM.render(<App />, document.getElementById('root'));
// });



// WEBPACK FOOTER //
// ./src/index.js